(() => {
  class MobileStickyAddToCart {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.target = productInfo.querySelector('[data-sticky-atc-target]');
      this.stickyBar = productInfo.querySelector('[data-sticky-atc]');
      this.stickyButton = productInfo.querySelector('[data-sticky-atc-button]');
      this.stickyText = productInfo.querySelector('[data-sticky-atc-text]');
      this.mainSubmit = productInfo.querySelector('.product-qty-button .product-form__submit');
      this.observer = null;
      this.buttonObserver = null;

      if (!this.target || !this.stickyBar || !this.stickyButton || !this.mainSubmit) return;

      document.body.appendChild(this.stickyBar);
      this.stickyButton.addEventListener('click', this.onStickyClick.bind(this));
      this.observeMainButton();
      this.startObserving();
    }

    onStickyClick() {
      if (this.mainSubmit.dataset.bisTrigger === 'true') {
        this.mainSubmit.click();
        return;
      }

      if (this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true') return;
      this.mainSubmit.click();
    }

    startObserving() {
      if (this.observer) return;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.target);
    }

    observeMainButton() {
      const syncButton = () => {
        this.stickyButton.className = this.mainSubmit.className;
        this.stickyButton.setAttribute('data-sticky-atc-button', '');

        const isBis = this.mainSubmit.dataset.bisTrigger === 'true';
        const isDisabled =
          !isBis &&
          (this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true');
        this.stickyButton.disabled = isDisabled;
        this.stickyButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
        this.stickyButton.classList.toggle('loading', this.mainSubmit.classList.contains('loading'));

        const mainText = this.mainSubmit.querySelector('span');
        if (mainText && this.stickyText) {
          this.stickyText.textContent = mainText.textContent;
        }
      };

      this.buttonObserver = new MutationObserver(syncButton);
      this.buttonObserver.observe(this.mainSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        subtree: true,
        characterData: true,
        childList: true,
      });
      syncButton();
    }
  }

  const init = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.querySelector('[data-sticky-atc]')) {
        new MobileStickyAddToCart(productInfo);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
